export default "__VITE_ASSET__9ab8d49b__"